export const MONO_FONT = '"Roboto Mono", ui-monospace, monospace';
